import { resolveImagePath } from '@/utils/imageResolver';

export function Mission() {
  const missionImageUrl = resolveImagePath('/images/mission-aircraft.jpg');

  return (
    <section className="bg-blue-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tight">
              OUR MISSION
            </h2>
            <div className="space-y-4">
              <p className="text-lg">
                To preserve a vibrant aviation community in a friendly hometown atmosphere and to foster the future generations of aviators.
              </p>
              <p className="text-lg">
                Please don't hesitate to contact us to learn more!
              </p>
            </div>
            <div className="pt-4">
              <a
                href="/contact"
                className="inline-block bg-white text-blue-900 px-6 py-2 font-semibold hover:bg-gray-100 transition-colors duration-200"
              >
                Contact
              </a>
            </div>
          </div>

          {/* Aircraft Image */}
          <div className="relative">
            {missionImageUrl && (
              <img
                src={missionImageUrl}
                alt="Aircraft at Simsbury Airport"
                className="w-full h-auto object-cover rounded-lg shadow-lg"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}